import { useQuery } from 'react-query';
import { getEducationMaterialCategories } from '../../educationMaterials';
import QueryKeys from '../queryKeys';
import { OrganizationQueryParams } from 'interfaces/queryParams';
import { IQueryRequest } from 'interfaces/request';

const useEducationMaterialCategories = ({
  params,
  options,
}: IQueryRequest<OrganizationQueryParams>) => {
  return useQuery({
    ...options,
    queryFn: async () => {
      const { data } = await getEducationMaterialCategories(
        params.organizationId
      );
      return data.data;
    },
    queryKey: [QueryKeys.getEducationMaterialCategories, params.organizationId],
  });
};

export default useEducationMaterialCategories;
